import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from 'bv-components';
import { ScrollableContext } from 'bv-contexts';

const BannerImg = ({
  bgUrl,
  textUrl,
  bannerSize,
}) => {
  const scrollableRef = useContext(ScrollableContext);

  return (
    <div className={`bv-slider-item__wrapper bv-slider-item__wrapper--${bannerSize}`}>
      { bgUrl && (
        <LazyImage
          className="bv-slider-item__wrapper-bg"
          src={bgUrl}
          scrollableRef={scrollableRef}
          webp
        />
      )}
      { textUrl && (
        <div className="bv-slider-item__wrapper-text" style={{ 'background-image': `url("${textUrl}")` }} />
      )}
    </div>
  );
};

BannerImg.propTypes = {
  bgUrl: PropTypes.string.isRequired,
  textUrl: PropTypes.string.isRequired,
  bannerSize: PropTypes.string.isRequired,
};

export default BannerImg;
